module.exports = __webpack_public_path__ + "static/media/the_barn_on_66.c11d8d97.jpg";